<div class="tw-flex tw-justify-between tw-items-center tw-mb-6">
  <h1 class="tw-text-2xl tw-font-bold tw-text-gray-800 dark:tw-text-gray-100 tw-my-0">
    Your Downloads
  </h1>
</div>

<app-downloads-list></app-downloads-list>
